






























import { Component, Vue } from 'vue-property-decorator';
import { MessageBox } from 'mint-ui';
import { ajaxWechatGroupDelete, ajaxUserInfo } from '@/server';
import bianjibai from '../../../assets/image/bianjibai.png';
// mixins
import MyHomeMixins from '../MixinsFunc/MyHomeMixins'; 
// 声明组件*****************
@Component({
  components: {

  },
  mixins: [MyHomeMixins]
})
export default class GroupList extends Vue {
    // 属性*****************
    private bianjibai: string = bianjibai;
    created ():void {
        
    }
    async mounted () {
        // 如果 有群组 就请求群列表
        if(this.$store.state.user_info.info_user_wechat.wechat_group_id >=0 ){
            let data = await this['getGroupInfo']();
            document.title = this['$getObjectValue'](data,'data.info_wechat_group.name');
            await this['getGroupMembers']();
        }
    }
  
    // 方法*****************
    //移除群员
    private deleteMessage(): void {
        MessageBox.confirm('是否移除该成员?','').then(action => {
            console.log('888')
        }).catch(error=>{
            console.log(error)
        })
    }
    // 解散群组
    private deleteGroup(): void {
        MessageBox.confirm('请确认是否解散群组?解散后组内成员将无法接收相关设备报警以及无法查看设备信息','').then(action => {
            ajaxWechatGroupDelete({
                wechat_group_id: this.$store.state.user_info.info_user_wechat.wechat_group_id,
            }).then( async(res)=>{
                await this['getUserInfo']();
                this['$message']({
                    value: '解散群组成功'
                })
                this.$router.go(-1);
            }).catch(error=>{
                console.log(error)
            })
        }).catch(error=>{
            console.log(error)
        })
    }


    // computed
    get routeQuery(): object {
        return {
            ...this.$route.query,
            type: 'edit'
        }
    }
    
}
